<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="checkout-tabs">
      <b-tabs
          pills
          v-model="settingsTabs"
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-lg-2 col-12 col-sm-12"
          @activate-tab="handleCurrentTab"
      >
        <template v-for="(tab, index) in tabs">
          <b-tab :active="tab.active" :key="index" :disabled="tab.val === 'marketplaces' && !$auth.priv('has-subscription')">
            <template v-slot:title>
              <i class="d-block check-nav-icon mt-4 mb-2" :class="tab.icon"></i>
              <p class="fw-bold mb-4">{{ tab.name }}</p>
            </template>
            <subscription v-if="tab.val === 'subscription'" :open="settingsTabs === 0"/>
            <market-places v-if="tab.val === 'marketplaces'" :open="settingsTabs === 1"/>
            <store-settings v-if="tab.val === 'storeSettings'" :open="settingsTabs === 2"/>
          </b-tab>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import MarketPlaces from "./Components/MarketPlaces";
import Subscription from "./Components/Subscription";
import StoreSettings from "./Components/StoreSettings";

export default {
  page() {
    return {
      title: this.$t('pages.settings.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {MarketPlaces, Subscription, StoreSettings},
  data() {
    return {
      title: this.$t('pages.settings.title'),
      items: [
        {
          text: this.$t('pages.settings.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.settings.items.second'),
          active: true,
        },
      ],
      tabs: [
        {
          icon: "mdi mdi-account-box",
          name: this.$t('pages.settings.tabs.subscription'),
          val: "subscription"
        },
        {
          icon: "mdi mdi-shopping",
          name: this.$t('pages.settings.tabs.marketplace_settings'),
          val: "marketplaces"
        },
        {
          icon: "mdi mdi-shopping",
          name: this.$t('pages.settings.tabs.store_settings'),
          val: "storeSettings"
        },
      ],
      userMarketPlace: null,
      settingsTabs: null
    };
  },
  watch: {
    '$route.query'(newVal) {
      if (newVal.tab) {
        this.setActiveTab(newVal.tab)
      }
    }
  },
  methods: {
    setActiveTab(val) {
      const index = this.tabs.findIndex(x => x.val === val)
      if (index > -1) {
        this.settingsTabs = index
      }
    },
    handleSettings() {
      const query = this.$route.query
      if (query.tab) {
        this.tabs.forEach(item => {
          if (query.tab === item.val) {
            item.active = true
          }
        })
      }
    },
    handleCurrentTab(e) {
      this.currentTab = e
      this.$router.replace({name: 'settings', query: {tab: this.tabs[e].val}})
    }
  },
  created() {
    this.handleSettings()
  },

};
</script>

